import i18next from 'i18next';

i18next.addResources('es', 'selectSearchFilter', {
  selectAll: 'Seleccionar todos'
});

i18next.addResources('en', 'selectSearchFilter', {
  selectAll: 'Select all'
});

i18next.addResources('pt', 'selectSearchFilter', {
  selectAll: 'Selecionar todos'
});
